export default "__VITE_ASSET__941903da__"